import React, { useState } from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { makeStyles, FormControlLabel, useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	container: {
		placeItems: 'normal',
		maxWidth: ({ isMobile }) => isMobile && 200,
		width: ({ isMobile, width }) => (isMobile ? 200 : width),
		margin: 0,
	},
	label: {
		minWidth: 120,
		marginRight: 10,
		color: ({ disabled, touched, hover }) =>
			(touched || hover) && !disabled ? theme.palette.primary.main : 'black',
	},
}));

const SimpleDate = ({
	label,
	name,
	onChange,
	value,
	width = '100%',
	disabled = false,
	labelPos = 'top',
	style = {},
	containerClass = '',
}) => {
	const isMobile = useMediaQuery('(max-width: 768px)');
	const [touched, setTouched] = useState(false);
	const [hover, setHover] = useState(false);
	const classes = useStyles({ isMobile, width, disabled, touched, hover });

	return (
		<FormControlLabel
			className={classes.container + ` ${containerClass}`}
			label={<p className={classes.label}>{label}</p>}
			labelPlacement={isMobile ? 'top' : labelPos}
			control={
				<KeyboardDatePicker
					autoOk
					fullWidth
					style={style}
					size="small"
					variant="inline"
					inputVariant="outlined"
					format="dd/MM/yyyy"
					placeholder="DD/MM/YYYY"
					name={name}
					value={value}
					disabled={disabled}
					onChange={(date) => onChange({ target: { value: date, name: name } })}
					onMouseEnter={() => setHover(true)}
					onMouseLeave={() => setHover(false)}
					onBlur={() => setTouched(false)}
					onFocus={(e) => setTouched(true)}
				/>
			}
		/>
	);
};

export default SimpleDate;
